module.exports = __webpack_public_path__ + "static/media/situp.d011a502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/situp.jpg
// module id = 35
// module chunks = 1